import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 15px;

  @media (min-width: 576px) {
    width: 576px;
  }

  @media (min-width: 768px) {
    width: 768px;
  }

  @media (min-width: 992px) {
    width: 992px;
  }

  @media (min-width: 1200px) {
    width: 1200px;
  }
`;

export default Container;
